import axios from './common';

const state = {
    categories: [],
    categoriesQueryParams: {
        description: null,
        limit: 10,
        page: 1,
    },
    currentCategoryItem: null,
    editableCategoryItem: null,
    categoriesLoading: false,
    categoryItemLoading: false,
    categoryApiError: null,
    totalCategories: 0,
};

const getters = {
    categories: state => {
        return state.categories;
    },
    categoriesQueryParams: state => {
        return state.categoriesQueryParams;
    },
    categoriesLoading: state => {
        return state.categoriesLoading;
    },
    currentCategoryItem: state => {
        return state.currentCategoryItem;
    },
    editableCategoryItem: state => {
        return state.editableCategoryItem;
    },
    categoryItemLoading: state => {
        return state.categoryItemLoading;
    },
    categoryApiError: state => {
        return state.categoryApiError;
    },
    totalCategories: state => {
        return state.totalCategories;
    },
};

const actions = {
    getCategories(context) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: 'Loading Categories',
        }, {root: true}).then(() => context.commit('setCategoriesLoading', true));

        axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/categories/`, {
            params: context.state.categoriesQueryParams,
        })
            .then(response => {
                context.dispatch('addNotification', {
                    status: 'success',
                    message: 'Categories successfully loaded',
                }, {root: true}).then(function() {
                    context.commit('setCategoriesLoading', false);
                    context.commit('setCategories', response.data);
                });
            });
    },
    async deleteCategory(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Deleting Category "${item.name}"`,
        }, {root: true}).then(() => context.commit('setCategoryItemLoading', true));

        try {
            await axios.delete(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/categories/${item._id}`);
            await context.dispatch('addNotification', {
                status: 'success',
                message: `Successfully deleted Category "${item.name}"`,
            }, {root: true});
            return true;
        } catch(error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Category "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Delete failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('setCategoryApiError', error);
                    console.error('categoryApiError', error);
                });
            }
            return false;
        } finally {
            context.commit('setCategoryItemLoading', false);
            await context.dispatch('clearCategoryItems');
            await context.dispatch('getCategories');
        }
    },
    async getCategory(context, item) {
        context.dispatch('addNotification', {
            status: 'loading',
            message: `Retrieving Category "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setCategoryItemLoading', true);
            context.commit('setCategoryApiError', null);
        });

        try {
            const response = await axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/categories/${item._id}`);
            context.commit('setCurrentCategoryItem', response.data);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Category "${item.name}" deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Retrieval failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    console.error('categoryApiError', error);
                });
            }
        } finally {
            context.commit('setCategoryItemLoading', false);
        }
    },
    async editCategory(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Editing Category "${item.name}"`,
        }, {root: true}).then(function() {
            context.commit('setCategoryItemLoading', true);
            context.commit('setCategoryApiError', null);
        });

        try {
            await axios.put(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/categories/${item._id}`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Category "${item.name}" successfully edited `,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Category "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Edit failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('categoryApiError', error);
                    console.error('categoryApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setCategoryItemLoading', false);
            await context.dispatch('clearCategoryItems');
            await context.dispatch('getCategories');
        }
    },
    async addCategory(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Adding Category "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setCategoryItemLoading', true);
            context.commit('setCategoryApiError', null);
        });

        try {

            await axios.post(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/categories/`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Category "${item.name}" successfully added`,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response) {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Failed to add Category "${item.name}", please try again`,
                }, {root: true}).then(() => {
                    context.commit('setCategoryApiError', error.response.data);
                });
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Add failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    context.commit('setCategoryApiError', error);
                    console.error('categoryApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setCategoryItemLoading', false);
            await context.dispatch('getCategories');
        }
    },
    clearCategoryItems(context) {
        context.commit('setCurrentCategoryItem', null);
        context.commit('setEditableCategoryItem', null);
    },
    clearCategoryApiError(context) {
        context.commit('setCategoryApiError', null);
    },
    setCategoryPaginationOptions(context, options) {
        context.commit('categoryPaginationOptions', options);
    },
    setCategoriesSearch(context, search) {
        context.commit('categoriesSearch', search);
    },
};

const mutations = {
    categoryPaginationOptions(state, options) {
        state.categoriesQueryParams.limit = options.itemsPerPage ?? 10;
        state.categoriesQueryParams.page = options.page ?? 1;
    },
    categoriesSearch(state, search) {
        state.categoriesQueryParams.description = `/${search.trim()}/i`;
    },
    setCategories(state, responseData) {
        state.categories = responseData.docs;
        state.totalCategories = responseData.totalDocs;
    },
    setCurrentCategoryItem(state, item) {
        state.currentCategoryItem = item;
        state.editableCategoryItem = {...item};
    },
    setEditableCategoryItem(state, item) {
        state.editableCategoryItem = item;
    },
    setCategoryItemLoading(state, isLoading) {
        state.categoryItemLoading = isLoading;
    },
    setCategoriesLoading(state, isLoading) {
        state.categoriesLoading = isLoading;
    },
    setCategoryApiError(state, error) {
        state.categoryApiError = error;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
